import { createFileRoute } from '@tanstack/react-router'

import { Page } from '@/components/page'
import { PartForm, emptyDraft } from '@/features/parts/PartForm'

export const Route = createFileRoute('/parts/new')({ component: NewPartPage })

function NewPartPage() {
  return (
    <Page title="New part" description="Add something to the inventory.">
      <PartForm initial={emptyDraft()} />
    </Page>
  )
}
